module.exports = __webpack_public_path__ + "static/media/fermer-message-membre.4544eb34.png";